import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9D8C1CEE-19BE-4B0B-85CC-DEB829F9F045
 * name folder
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder.svg
 * tags
 * - Files / Folders 
 */
export const FolderIcon = createSvgIcon(<><path d="M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" /></>, 'FolderIcon');
export default FolderIcon